import React from "react";
import { FormattedMessage } from "react-intl";
const PaymentCancelDisclosure = () => (<FormattedMessage tagName="p" id="paymentCancelDisclosure.message" defaultMessage={"A consumer may stop payment of a preauthorized electronic fund transfer from the consumer’s "
    + "account by notifying the financial institution orally or in writing at least three business "
    + "days before the scheduled transfer date or, by contacting the financial institution that "
    + "holds your Funding Account."}/>);
export default PaymentCancelDisclosure;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/PaymentCancelDisclosure/PaymentCancelDisclosure.tsx